import React from 'react';
import { useInitEssentials } from '../hooks/essentials';
export const EssentialsContext = React.createContext(undefined);
export const EssentialsContextProvider = ({ essentials, children, }) => (React.createElement(EssentialsContext.Provider, { value: essentials }, children));
export function withEssentialsContext(Component) {
    return (props) => {
        const { essentials, ready } = useInitEssentials({
            i18n: props?.i18n,
            experiments: props?.experiments,
            languageCode: props?.languageCode,
        });
        if (!ready) {
            return null;
        }
        return (React.createElement(EssentialsContextProvider, { essentials: essentials },
            React.createElement(Component, { ...props })));
    };
}
export const useEssentials = () => {
    const context = React.useContext(EssentialsContext);
    if (context === undefined) {
        throw new Error('useEssentials must be used within a EssentialsContextProvider');
    }
    return context;
};
//# sourceMappingURL=essentials-context.js.map